import React, { Fragment } from 'react';

const ChangeHub = () => (
  <Fragment>
    <p>
      To shift your future bookings from one location to another, simply
      cancel the current booking in accordance with our 24-hour
      cancellation policy (no charge) and rebook at the hub of your
      preference. When setting up a new booking, click on "Change" in the
      address section under the "Hub" category and swipe “nearby” upwards
      or click on the map pin to confirm your vehicle pickup location.
      Please note that the initial booking rate won't be retained; you'll
      be charged according to the new booking rate. For bookings cancelled
      less than 24 hours before the start time, booking fees will apply.
    </p>
  </Fragment>
);

export default ChangeHub;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingHub/ChangeHub.js